export default class ScanViewModel {
    id = null;
    assetId = null;
    name = null;
    description = null;

    numberOfLenses = null;      // 1 = standard/single-lens | 2 = 360
    captureMethod = null;       // "Walkthrough" | "Drone" (360 scans only); null otherwise

    sourceFileName = null;
    sourceFileType = null;
    sourceFileUploaded = false;

    status = null;
    numberOfFrames = 0;
    createdOn = null;
    createdBy = null;
    statusUpdatedOn = null;
    videoUploaded = false;
    generationStarted = false;
    modelGenerated = false;
    perimeter = null;   // raw perimeter JSON string (local coords) for the minimap; null until captured

    constructor(scan){
        this.id = scan.id;
        this.assetId = scan.assetId;
        this.name = scan.name;
        this.description = scan.description;

        this.numberOfLenses = scan.numberOfLenses ?? null;
        this.captureMethod = scan.captureMethod ?? null;

        this.sourceFileName = scan.sourceFileName;
        this.sourceFileType = scan.sourceFileType;
        this.sourceFileUploaded = scan.sourceFileUploaded;

        this.status = scan.status;
        this.statusUpdatedOn = scan.statusUpdatedOn;
        this.numberOfFrames = scan.numberOfFrames;
        this.createdBy = scan.createdBy;
        this.createdOn = scan.createdOn;
        this.videoUploaded = scan.videoUploaded;
        this.generationStarted = scan.generationStarted;
        this.modelGenerated = scan.modelGenerated;
        this.perimeter = scan.perimeter ?? null;
    }

    toLocalTime(isoString){
        const date = new Date(isoString);

        return date.toLocaleString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
    }
}